<c3-config-section-box
  [title]="TP_SECTIONS_INFO['exams'].label"
  [icon]="TP_SECTIONS_INFO['exams'].icon"
>
  <p config-description>{{ TP_SECTIONS_INFO["exams"].description }}</p>

  <div [c3ConfigForm]="this" [c3ConfigFormHideSaveBtn]="true">
    <div class="d-flex flex-row flex-wrap justify-between items-center gap-12">
      <div class="d-flex flex-row flex-wrap justify-start items-center gap-12">
        <mat-checkbox class="show-hide-ended" (change)="toggleShowEnded($event)">
          Mostra terminati
        </mat-checkbox>
      </div>

      <ion-toolbar>
        <ion-buttons slot="end" class="c3-flex-wrap ion-justify-content-end">
          <ion-button (click)="onRefreshList()" c3Tooltip="Ricarica lista">
            <ion-icon slot="icon-only" [src]="'refresh' | getIcon"></ion-icon>
          </ion-button>
          <ion-button color="secondary" (click)="openEditDialog()" fill="solid">
            <span class="ion-hide-md-down">Aggiungi</span>
            <ion-icon slot="end" [src]="'plus' | getIcon"></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </div>

    <div *ngIf="viewType === 'table'" class="content-container table-container">
      <table
        mat-table
        matSortActive="end_date"
        matSortDirection="desc"
        class="flex-fill"
        [dataSource]="dataSource"
        matSort
      >
        <ng-container matColumnDef="title">
          <th
            class="flex-45 justify-start items-end"
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
          >
            Esame
          </th>
          <td
            class="flex-45 justify-start items-center"
            [ngClass]="{ ended: element.metadata.end_date <= today }"
            mat-cell
            *matCellDef="let element"
          >
            <span>{{ element.data.title }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="start_date">
          <th
            class="flex-15 justify-start items-end"
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
          >
            Promemoria Inizio
          </th>
          <td
            class="flex-15 justify-start items-center"
            [ngClass]="{ ended: element.metadata.end_date <= today }"
            mat-cell
            *matCellDef="let element"
          >
            <span>{{ element.metadata.start_date | date: "dd/MM/yyyy" }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="end_date">
          <th
            class="flex-15 justify-start items-end"
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
          >
            Promemoria Fine
          </th>
          <td
            class="flex-15 justify-start items-center"
            [ngClass]="{ ended: element.metadata.end_date <= today }"
            mat-cell
            *matCellDef="let element"
          >
            <span>{{ element.metadata.end_date | date: "dd/MM/yyyy" }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="freqValue">
          <th
            class="flex-25 justify-start items-end"
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
          >
            Frequenza
          </th>
          <td
            class="flex-25 justify-start items-center"
            [ngClass]="{ ended: element.metadata.end_date <= today }"
            mat-cell
            *matCellDef="let element"
          >
            <ng-container [ngSwitch]="element.data.regular.frequency.type">
              <span *ngSwitchCase="'every_x_days'">
                <ng-container
                  *ngIf="
                    element.data.regular.frequency.values[0] % 365 === 0;
                    then years;
                    else other
                  "
                >
                </ng-container>
                <ng-template #years>
                  <span>Ogni {{ element.data.regular.frequency.values[0] / 365 }} anni</span>
                </ng-template>
                <ng-template #other>
                  <ng-container
                    *ngIf="
                      element.data.regular.frequency.values[0] % 30 === 0;
                      then months;
                      else days
                    "
                  >
                  </ng-container>
                  <ng-template #months>
                    <span>Ogni {{ element.data.regular.frequency.values[0] / 30 }} mesi</span>
                  </ng-template>
                  <ng-template #days>
                    <span>Ogni {{ element.data.regular.frequency.values[0] }} giorni</span>
                  </ng-template>
                </ng-template>
              </span>
              <span *ngSwitchCase="'at_need'">Al bisogno</span>
              <span *ngSwitchDefault> Sconosciuto </span>
            </ng-container>
          </td>
        </ng-container>

        <ng-container matColumnDef="doctor">
          <th
            class="flex-15 justify-start items-end"
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
          >
            Prescritto da
          </th>
          <td class="flex-15 justify-start items-center" mat-cell *matCellDef="let element">
            @if (element.metadata.doctor && element.metadata.doctor.name) {
              <span>
                {{ element.metadata.doctor.name }}
              </span>
            } @else {
              <span>-</span>
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th class="flex-10 justify-start items-end" mat-header-cell *matHeaderCellDef>Azioni</th>
          <td class="flex-10 justify-start items-center" mat-cell *matCellDef="let element">
            <button mat-icon-button (click)="openEditDialog(element)" matTooltip="Apri o Modifica">
              <ion-icon slot="icon-only" color="primary" [src]="'pencil' | getIcon"></ion-icon>
            </button>
            <button mat-icon-button (click)="onDeleteExamination(element)" matTooltip="Cancella">
              <mat-icon color="warn" svgIcon="delete-circle"></mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>

      <div
        class="empty-msg-box d-flex flex-row justify-center items-center"
        *ngIf="dataSource.data.length === 0"
      >
        <i
          >Non sono presenti esami. Inizia ad aggiungerli utilizzando i bottoni sopra la tabella in
          alto a destra</i
        >
      </div>

      <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
    </div>

    <div *ngIf="viewType === 'chart'" class="content-container">
      <c3-exams-chart [timeRange]="viewPeriod" [reminders]="dataSource.filteredData">
      </c3-exams-chart>
    </div>
  </div>
</c3-config-section-box>
